import './v-loading-styles.css'

let isLoading = false, position = 'initial'

const toggleLoader = (el, { value, arg, modifiers }) => {
  if (value) {
    if (!!el.querySelector('.v-loading')) return
    position = el.style.position || 'initial'
    el.style.position = 'relative'
    const spinner = document.createElement('div')
    if (arg) spinner.style.borderColor = `transparent ${arg}`
    spinner.classList.add('v-loading', ...Object.keys(modifiers))
    el.appendChild(spinner)
    isLoading = true
  }
  else {
    el.style.position = position
    el.querySelector('.v-loading')?.remove()
    isLoading = false
  }
}

export default {

  mounted: (el, binding) => {
    toggleLoader(el, binding)
  },
  beforeUpdate: (el, binding) => {
    toggleLoader(el, binding)
  },

}